export default __webpack_public_path__ + "94b6812e4dcc95646bd806b17dfeac17.png";